import { Edge, Node } from 'reactflow';
import { Form, FormFiled, FormTemplate, Phase, TeamMember } from '.';
import { ReceivedNodeData } from '../modules/projects/models';

export enum WorkflowStatus {
  Draft = 'Draft',
  ReadyForAssignment = 'ReadyForAssignment',
  Active = 'Active',
  Ongoing = 'Ongoing',
  Archived = 'Archived',
}

export enum WorkflowBuilderMode {
  Create = 'create',
  Edit = 'edit',
  View = 'view',
}

export interface CustomNode {
  type: 'Start' | 'End' | 'Receiver' | 'Conditional';
  id: string;
  xAxis: Node['position']['x'];
  yAxis: Node['position']['x'];
  receivedRoles?: ReceivedNodeData['receivedRoles'];
  receivedUsers?: ReceivedNodeData['receivedUsers'];
  hasRejection: boolean;
}

export interface CustomEdge {
  type: 'Normal' | 'Conditional' | 'Rejected';
  source: Edge['source'];
  target: Edge['target'];
  conditionField?: FormFiled['id'];
  conditionValue1?: string;
  conditionValue2?: string;
  conditionOperation?: string;
}

export interface WorkflowItem {
  id: number;
  name: string;
  formId: number;
  formName: string;
  modifiedAt: string;
  modifiedBy: TeamMember;
  status: WorkflowStatus;
}

export interface Workflow {
  id: number;
  name: string;
  form: Form & { id: number };
  createdBy: TeamMember;
  modifiedBy: TeamMember;
  nodes: CustomNode[];
  edges: CustomEdge[];
  createdAt: string;
  modifiedAt: string;
  durationUnit?: DurationUnit;
  durationValue?: number;
}

export type PaginatedWorkflow = {
  page: number;
  size?: number;
  phaseId?: string;
  projectId?: string;
  formName?: string;
  workflowName?: string;
};

export interface NewWorkflow {
  name: Workflow['name'];
  nodes: Workflow['nodes'];
  edges: Workflow['edges'];
  formTemplateId?: FormTemplate['id'];
  formId?: FormTemplate['id'];
  phaseId: Phase['id'];
}

export enum DurationUnit {
  Hour = 'Hour',
  Day = 'Day',
}
